export default __webpack_public_path__ + "static/media/backspace.24cd3fa1.wav";